import React, { useContext, useState, useEffect } from 'react';
import DashboardNavbar from '../../../examples/Navbars/DashboardNavbar';
import DashboardLayout from '../../../examples/LayoutContainers/DashboardLayout';
import Grid from '@mui/material/Grid';
import { getToken } from 'shared/const/token.helper';
import './quote.scss';
import { UserDataContext } from '../../../shared/context/userDataContext';
import { useLocation, useNavigate } from 'react-router';

const Quote = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const {
    selectedBusinessUnit,
    dataCenter,
    userRoles,
    sessionContext,
    getAuthProvider,
    getUsedPaymentMethod,
  } = useContext(UserDataContext);
  const [iframeUrl, setIframeUrl] = useState();
  const quoteId = urlParams.get('quoteId');
  const bookingDataId = urlParams.get('bookingDataId');
  const brand = urlParams.get('brand');
  const token = getToken();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    let additonalData = null;

    // fixme:: this is a temporary solution to redirect to welcome page if the user is creating a quote and is an azure user
    const isCreatingQuoteAndIsAzureUser =
      getAuthProvider().isAzureProvider() && !bookingDataId;

    if (isCreatingQuoteAndIsAzureUser) {
      navigate('/welcome-page');
    }

    if (location.state && location.state.welcomePageRedirection) {
      const { welcomePageRedirection, tail } = location.state;
      additonalData = new URLSearchParams(welcomePageRedirection).toString();
      window.history.replaceState(tail, '');
    }
    const brandCode = brand ? brand : selectedBusinessUnit.brand;

    const buildUrl = async () => {
      let url = `${
        dataCenter.widgetUrl
      }?brand=${brandCode}&token=${token}&sessionToken=${sessionContext}${
        quoteId ? `&quoteId=${quoteId}` : ''
      }${bookingDataId ? `&bookingDataId=${bookingDataId}` : ''}${
        additonalData ? `&${additonalData}` : ''
      }`;
      const usedPaymentMethod = await getUsedPaymentMethod();
      if (usedPaymentMethod) {
        url += `&paymentMethod=${usedPaymentMethod}`;
      }
      setIframeUrl(url);
    };
    buildUrl();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionContext, userRoles, selectedBusinessUnit, bookingDataId, brand]);
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Grid container style={{ marginTop: '0' }} spacing={3}>
        {dataCenter.widgetUrl && (
          <iframe src={iframeUrl} allow="clipboard-write"></iframe>
        )}
      </Grid>
    </DashboardLayout>
  );
};

Quote.propTypes = {};

Quote.defaultProps = {};

export default Quote;
